export const WA_NUMBER = "5586981909090";
const t = (s) => encodeURIComponent(s);

export const WA_SCHEDULE = `https://wa.me/${WA_NUMBER}?text=${t("Olá! Gostaria de agendar uma consulta na Clínica COB.")}`;
export const WA_FLOAT = `https://wa.me/${WA_NUMBER}?text=${t("Olá! Gostaria de falar com a Clínica COB.")}`;
export const WA_ONLINE = `https://wa.me/${WA_NUMBER}?text=${t("Olá! Gostaria de saber sobre consulta online na Clínica COB.")}`;

export const PHONE_DISPLAY = "+55 86 98190-9090";
export const INSTAGRAM_HANDLE = "@cob.ortopedia.fisioterapia";
export const INSTAGRAM_URL = "https://instagram.com/cob.ortopedia.fisioterapia";
export const MAPS_URL = "https://maps.app.goo.gl/ekVS9y44ieWQ36Kg9";
export const MAPS_EMBED = "https://www.google.com/maps?q=-5.0407292,-42.8143572&z=17&output=embed";

const ASSETS = "https://customer-assets-rejwkqb3.emergentagent.net/job_cob-teresina/artifacts";
export const IMAGES = {
  care: `${ASSETS}/c0nl20e9_WhatsApp%20Image%202026-09-10%20at%2012.06.50%20%284%29.jpeg`,
  office: `${ASSETS}/muh19p57_WhatsApp%20Image%202026-09-10%20at%2012.06.50%20%283%29.jpeg`,
  reception: `${ASSETS}/itds7w74_WhatsApp%20Image%202026-09-26%20at%2020.10.00.jpeg`,
  facade: `${ASSETS}/x2bejaub_WhatsApp%20Image%202026-09-10%20at%2012.06.50%20%281%29%20-%20Copia.jpeg`,
  doctor: `${ASSETS}/tws3ycck_WhatsApp%20Image%202026-09-10%20at%2012.27.40.jpeg`,
};

export const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "A Clínica", href: "#clinica" },
  { label: "Modalidades", href: "#especialidades" },
  { label: "Equipe", href: "#equipe" },
  { label: "Fisioterapia", href: "#fisioterapia" },
  { label: "Pilates", href: "#pilates" },
  { label: "Convênios", href: "#convenios" },
  { label: "Avaliações", href: "#avaliacoes" },
  { label: "Conteúdos", href: "#conteudos" },
  { label: "Contato", href: "#contato" },
];
